import type { ConfigurationResourceListResponseBffV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type { ConfigurationListMapped } from '../../models/configurationList.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapConfigurationsList(
  configurationResourceList: ConfigurationResourceListResponseBffV2Api,
): ConfigurationListMapped {
  return {
    pagination: configurationResourceList.pagination,
    data: configurationResourceList.data.map((item) => ({
      id: toString(item.id),
      name: toString(item.name),
      description: item.description,
      deploymentPriority: item.deploymentPriority,
      creationDate: toIsoStringIfDate(item.creationDate),
      updateDate: toIsoStringIfDate(item.updateDate),
      creatorId: item.creator.id,
      createdBy: item.creator.name, // TICKET MDMGT-7043 Upgraded api-sdk, and on new api, name doesn't exist
    })),
  };
}
